/**
 * GENERATED by ben/tools/crm-glyphs/build_glyphs.py --react (symbol set v2, decided by Arif 2026-09-09).
 * Do not edit by hand: change the tool, regenerate, commit. The markup is the effect stack the design
 * document (CRM-TILE-SYSTEM-2026-09-08.html) renders inline; every id carries the instance prefix `id`
 * (React useId) because ids are document-wide and `use` would otherwise resolve another glyph's defs.
 */
import type { ReactElement } from 'react';
import { GlyphPulse } from './pulse';
import { GlyphCall } from './call';
import { GlyphCreator } from './creator';
import { GlyphPerson } from './person';
import { GlyphTeam } from './team';
import { GlyphAgency } from './agency';
import { GlyphLead } from './lead';
import { GlyphDeal } from './deal';
import { GlyphEnrollment } from './enrollment';
import { GlyphGameplan } from './gameplan';
import { GlyphPayment } from './payment';
import { GlyphWin } from './win';
import { GlyphPhase } from './phase';
import { GlyphDelivery } from './delivery';
import { GlyphAi } from './ai';
import { GlyphDashboard } from './dashboard';
import { GlyphReports } from './reports';
import { GlyphTasks } from './tasks';
import { GlyphPending } from './pending';
import { GlyphObjects } from './objects';
import { GlyphSettings } from './settings';
import { GlyphSidebar } from './sidebar';
import { GlyphWorkflows } from './workflows';
import { GlyphImports } from './imports';
import { GlyphExports } from './exports';
import { GlyphWebhooks } from './webhooks';
import { GlyphInbound } from './inbound';
import { GlyphHealth } from './health';
import { GlyphMembers } from './members';
import { GlyphIdentity } from './identity';
import { GlyphInstance } from './instance';
import type { GlyphName } from './names';

export { FUNCTION_GLYPH_NAMES, GLYPH_NAMES, type GlyphName, isGlyphName, OBJECT_GLYPH_NAMES } from './names';

/** The 31 symbols, by what they stand for: 15 objects, 16 function rows. */
export const GLYPHS = {
  pulse: GlyphPulse,
  call: GlyphCall,
  creator: GlyphCreator,
  person: GlyphPerson,
  team: GlyphTeam,
  agency: GlyphAgency,
  lead: GlyphLead,
  deal: GlyphDeal,
  enrollment: GlyphEnrollment,
  gameplan: GlyphGameplan,
  payment: GlyphPayment,
  win: GlyphWin,
  phase: GlyphPhase,
  delivery: GlyphDelivery,
  ai: GlyphAi,
  dashboard: GlyphDashboard,
  reports: GlyphReports,
  tasks: GlyphTasks,
  pending: GlyphPending,
  objects: GlyphObjects,
  settings: GlyphSettings,
  sidebar: GlyphSidebar,
  workflows: GlyphWorkflows,
  imports: GlyphImports,
  exports: GlyphExports,
  webhooks: GlyphWebhooks,
  inbound: GlyphInbound,
  health: GlyphHealth,
  members: GlyphMembers,
  identity: GlyphIdentity,
  instance: GlyphInstance,
} as const satisfies Record<GlyphName, (props: { readonly id: string }) => ReactElement>;
